import useAdministrationNamingSchemeColumns from './useAdministrationNamingSchemeColumns'

export default useAdministrationNamingSchemeColumns
